import { SortingOrder } from './SortingIconButton'

export const getNextSorting: (order: SortingOrder) => SortingOrder = (
    order
) => {
    if (order === undefined) {
        return 'desc'
    }

    if (order === 'desc') {
        return 'asc'
    }

    return undefined
}
